
/** Slice name prefix — must be unique (Manage Employees also used the typo'd `manageEmpolyee`). */
export const MANAGE_ASSESSOR = 'manageAssessor';
export const GET_MANAGE_ASSESSOR = `${MANAGE_ASSESSOR}/getManageAssessorAction`;
export const SET_MANAGE_ASSESSOR = `${MANAGE_ASSESSOR}/setManageAssessorSaveAction`;
export const GET_MANAGE_ASSESSOR_UPDATE=`${MANAGE_ASSESSOR}/getManageAssessorUpdateAction`
